import axios from 'axios';

export async function estimate({coupons, products, address}) {
  const {data} = await axios.post('/api/?entity=billing&action=estimate', {coupons, products, address});
  return data;
}
